const getModelType = (uint8Array) => {
  if (
    uint8Array[0] === 0x67 &&
    uint8Array[1] === 0x6c &&
    uint8Array[2] === 0x54 &&
    uint8Array[3] === 0x46
  ) {
    return "glb";
  }

  const fbxHeader = new TextDecoder().decode(uint8Array.slice(0, 23));
  if (fbxHeader.includes("Kaydara FBX Binary") || fbxHeader.includes("; FBX")) {
    return "fbx";
  }

  const headerText = new TextDecoder().decode(uint8Array.slice(0, 80));
  if (headerText.trim().toLowerCase().startsWith("solid")) {
    return "stl";
  } else if (uint8Array.length > 84) {
    const dataView = new DataView(uint8Array.buffer);
    const triangleCount = dataView.getUint32(80, true);
    const expectedLength = 84 + triangleCount * 50;

    if (expectedLength === uint8Array.length) {
      return "stl";
    }
  }

  const textSnippet = new TextDecoder().decode(uint8Array.slice(0, 200));
  if (
    textSnippet.match(/^v\s/gm) ||
    textSnippet.match(/^f\s/gm) ||
    textSnippet.match(/^o\s/gm) ||
    textSnippet.includes("# Wavefront OBJ")
  ) {
    return "obj";
  }

  if (
    uint8Array[0] === 0x50 &&
    uint8Array[1] === 0x4b &&
    uint8Array[2] === 0x03 &&
    uint8Array[3] === 0x04
  ) {
    return "zip";
  }

  return "unknown";
};

export default getModelType;
